import { useMemo } from 'react'
import type { DesignEmbedSnapshot, DesignShape } from '../../types/design'
import { ShapeRenderer } from './ShapeRenderer'
import { DesignCanvasBackdrop, designCanvasStyle } from './canvasPresets'

type Props = {
  snapshot: DesignEmbedSnapshot
  maxWidth?: number
  maxHeight?: number
}

export const DesignSnapshotRenderer = ({ snapshot, maxWidth = 800, maxHeight = 600 }: Props) => {
  const shapesById = useMemo(() => new Map(snapshot.shapes.map((s) => [s.id, s as DesignShape])), [snapshot.shapes])
  const b = snapshot.bounds
  const pad = 24
  const viewBox = `${b.x - pad} ${b.y - pad} ${b.width + pad * 2} ${b.height + pad * 2}`
  const aspect = (b.width + pad * 2) / (b.height + pad * 2)
  const w = Math.min(maxWidth, maxHeight * aspect)
  const h = w / aspect
  return (
    <div className="dh-snap" style={{ width: w, height: h, borderRadius: 12, ...designCanvasStyle(snapshot.canvas), border: '1px solid rgba(51,65,85,0.5)' }}>{/* mosaic-keep: user data */}
      <svg width="100%" height="100%" viewBox={viewBox} preserveAspectRatio="xMidYMid meet">
        <defs>
          <marker id="arrow-end-TRIANGLE-94a3b8" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 Z" fill="#94a3b8" /></marker>{/* mosaic-keep: user data */}
          <linearGradient id="progressGrad" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor="#22c55e" /><stop offset="100%" stopColor="#38bdf8" /></linearGradient>{/* mosaic-keep: user data */}
        </defs>
        <DesignCanvasBackdrop canvas={snapshot.canvas} x={b.x - pad} y={b.y - pad} width={b.width + pad * 2} height={b.height + pad * 2} />
        {snapshot.shapes.map((s) => (
          <ShapeRenderer
            key={s.id}
            shape={s as DesignShape}
            shapesById={shapesById}
            resolved={s.resolved ?? null}
          />
        ))}
      </svg>
    </div>
  )
}
